import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import closeIcon from '../../../../assests/cancel.svg';
import downloadIcon from '../../../../assests/filedownload.svg';
import ordersIcon from '../../../../assests/food.png';
import offersIcon from '../../../../assests/offer.png';
import supportIcon from '../../../../assests/support.png';
import daalchinilogo from "../../../../assests/daalchinilogo.png";
import grouplogo from "../../../../assests/grouplogo1.svg"
import './QRCodeModal.css';

const QRCodeModal = ({ open, onClose, uid, onDownload }) => {
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(`https://www.daalchini.co.in/uuid?value=${uid}`)}`;

  const handleDownload = () => {
    if (onDownload) {
      onDownload(uid, qrCodeUrl);
    }
  };

  return (
    <Dialog
      open={open}
      onClick={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #FFEECE, #E0E8FF)',
          overflow: 'hidden',
        },
      }}
    >
      {/* Close Button */}
      {/* <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          zIndex: 1,
          background: 'rgba(255, 255, 255, 0.9)',
          '&:hover': {
            background: 'rgba(255, 255, 255, 1)',
          },
          width: '32px',
          height: '32px'
        }}
      >
        <img src={closeIcon} alt="Close" style={{ width: '16px', height: '16px' }} />
      </IconButton> */}

      <DialogContent sx={{ p: 0 }}>
        <Box className="qr-modal-container">
          {/* Header */}
          <Box className="qr-header">
            <img src={daalchinilogo} alt="Daalchini" className="header-logo" />
          </Box>

          {/* Main Content */}
          <Box className="qr-content">
            {/* QR Code with Logo in Center */}
            <Box className="qr-code-wrapper">
              <Box className="qr-code-container">
                <img
                  src={qrCodeUrl}
                  alt={`QR Code for ${uid}`}
                  className="qr-code-image"
                />
                {/* Logo in center of QR code */}
                <Box className="qr-center-logo">
                  <img src={grouplogo} alt="Daalchini" className="center-logo-image" />
                </Box>
                <div className="vm-dashboard-bulk-qr-divider"></div>
                {/* UID Display inside QR container at bottom */}
                <Box className="qr-uid-display">
                  <Typography variant="body2" className="qr-uid-label">
                    UID :
                  </Typography>
                  <Typography variant="h6" className="qr-uid-value">
                    {uid}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box className="scan-qr-button">
              <Typography variant="h6" className="scan-for-title">
                Scan For
              </Typography>
            </Box>
            <Box className="scan-for-section">
              <Box className="scan-for-container">

                <Box className="vmid-scan-options">
                  <Box className="scan-option-item">
                    <Box className="scan-icon-container">
                      <img src={ordersIcon} alt="Orders" className="scan-icon-image" />
                    </Box>
                    <Typography variant="body2" className="scan-option-text">Place Orders</Typography>
                  </Box>
                  <Box className="scan-option-item">
                    <Box className="scan-icon-container">
                      <img src={offersIcon} alt="Offers" className="scan-icon-image" />
                    </Box>
                    <Typography variant="body2" className="scan-option-text">Exciting Offers</Typography>
                  </Box>
                  <Box className="scan-option-item">
                    <Box className="scan-icon-container">
                      <img src={supportIcon} alt="Support" className="scan-icon-image" />
                    </Box>
                    <Typography variant="body2" className="scan-option-text">Get Support</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>


        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default QRCodeModal;